@if (assignments().length) {
  <div class="engagements-cell">
    <span class="engagements-cell-line">{{ summaryText() }}</span>

    @if (hiddenAssignmentsCount()) {
      <button
        type="button"
        class="engagements-cell-more"
        (click)="openDrawer()">
        +{{ hiddenAssignmentsCount() }} more...
      </button>
    }
  </div>
} @else {
  <span class="engagements-cell-empty">
    {{ 'admin.user.noEngagements' | translate }}
  </span>
}
